/* eslint-disable no-compare-neg-zero */
interface Props {
  totalPages: number;
  currentPage: number;
  showMax: number;
  nextText?: string;
  threeDots?: boolean;
  prevNext?: boolean;
  prevText?: string;
}

interface ItemPage {
  page: number;
  text: string;
  isCurrent: boolean;
  isThreeDots?: boolean;
}

const isCurrent = (page: number, currentPage: number) => currentPage === page;

const addThreeDots = (arr: Array<ItemPage>, props: Props) => {
  const threeDotsObj = { page: 0, text: '...', isCurrent: false, isThreeDots: true };

  arr[0].page !== 1 &&
    arr.unshift(threeDotsObj) &&
    arr.unshift({
      page: 1,
      text: '1',
      isCurrent: false
    });

  arr[arr.length - 1].page !== props.totalPages &&
    arr.push(threeDotsObj) &&
    arr.push({
      page: props.totalPages,
      text: `${props.totalPages}`,
      isCurrent: false
    });

  return arr;
};

const addNext = (arr: Array<ItemPage>, props: Props) => {
  const nextObj = {
    page: props.currentPage + 1,
    text: props.nextText,
    isCurrent: false
  } as ItemPage;

  arr.push(nextObj);

  return arr;
};

const addPrev = (arr: Array<any>, props: Props) => {
  const prevObj = {
    page: props.currentPage - 1,
    text: props.prevText,
    isCurrent: false
  };

  arr.unshift(prevObj);

  return arr;
};

const getPagination = (props: Props): Array<ItemPage> => {
  let arr = [] as Array<ItemPage>;
  let startAt = props.currentPage - Math.floor(props.showMax / 2);
  const isPositive = () => Math.sign(startAt);

  if (isPositive() === -1 || isPositive() === 0 || isPositive() === -0) startAt = 1;

  const max = props.showMax > props.totalPages ? props.totalPages : props.showMax;

  for (let i = 0; i < max; i++) {
    if (startAt + i > props.totalPages) continue;

    arr.push({
      page: startAt + i,
      text: `${startAt + i}`,
      isCurrent: isCurrent(startAt + i, props.currentPage)
    });
  }

  if (props.threeDots) {
    arr = addThreeDots(arr, props);
  }

  if (props.prevNext) {
    arr = addNext(arr, props);
    arr = addPrev(arr, props);
  }

  return arr;
};

export { getPagination };
